export const Theme = {
  primaryColor: 'rgba(3,169,244,1)',
  primaryAccent: '#0288d1',
  primaryColorDark: 'rgba(2,136,209,1)',
  primaryColorLight: 'rgba(79,195,247,1)',

  brandColor: 'rgb(0, 118, 190)',
  brandColorAccent: 'rgb(127, 194, 235)',
  brandColorSecondary: '#ff0018',
  secondaryColor: 'rgba(255,87,34,1)',

  mediumGrey: 'grey',
  disabled: 'rgba(200, 212, 218, 0.39)',
  lightGrey: 'rgba(245,245,245,1)',
  lighterGrey: 'rgba(250,250,250 ,1)',
  darkGrey: 'rgba(33,33,33,1)',
  lightMediumGrey: 'rgba(224,224,224,1)',
  warningColor: 'rgba(255,183,77,1)',

  brandColorLight: 'rgb(236, 244, 250)',
  warningColorLight: 'rgb(255, 250, 241)',
  successColorLight: 'rgb(237, 249, 242)',
  dangerColorLight: 'rgb(255, 241, 239)',

  successColor: 'rgb(32, 180, 88)',
  successColorDark: 'rgba(67,160,71,1)',
  successHover: '#efffd1',

  dangerColor: 'rgb(245, 75, 60)',
  dangerColorDark: 'rgba(211,47,47,1)',

  activeColor: '#8bc34a',
  inactiveColor: 'lightgray',

  fontColor: 'rgba(33,33,33,1)',
  primaryFont: 'roboto, sans-serif'
};

export default Theme;
